import TrafficScoreConfig from "./TrafficScoreConfig";

export default TrafficScoreConfig;
